import styled from "styled-components";

export const ContainerMain = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: ${props =>(props.$IsDetail? '330px': '100%')};
    height: 100%;
    position: relative;
    @media (min-width: 720px) {
        justify-content: flex-start;
        transition: 1s;
        box-shadow: ${props =>(props.$IsDetail? '2px -2px 2px 2px rgb(217, 217, 217)': 'none')};
        border-radius: ${props =>(props.$IsDetail? '10px': 'none')};
    }
    @media (orientation: landscape) and (max-width: 1200px){
        width: 280px;
        box-shadow: none;
        height: ${props =>(props.$IsDetail? '80%': '100%')};
    }
`;

export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    background: transparent;
    max-height: 100%;
    gap: ${props =>(props.$IsDetail? '25px': '80px')};
    transition: 1s;
    overflow-y: ${props =>(props.$IsDetail? 'auto': 'visible')};
    &::-webkit-scrollbar {
        width : 3px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: #ccc;
        border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background-color: #aaa
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-button {
        display: none;
    }
    @media (min-width: 720px) {
        flex-direction: ${props =>(props.$IsDetail? 'column': 'row')};
        justify-content: flex-start;
        align-items: flex-start;
    }
`;

export const NewColumn = styled.div`
    border-radius: 5px;
    min-width: 325px;
    display:flex;
    flex-direction: column;
    background-color: transparent;
    height: 100%;
    max-height: 100%;
    gap: 5px;
    width: 85%;
    @media (min-width: 720px) {
        width:25%;
    }
    @media (orientation: landscape) and (max-width: 1200px){
        min-width: 280px;
    }
`;

export const TitleContainer = styled.button`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 30px;
    background: transparent;
    cursor: pointer;
    border: none;
    box-shadow: none;
    user-select: none;
    outline: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -webkit-tap-highlight-color: transparent;
    background: #FFF;
    border-radius: 5px;
    box-shadow: 0px 1.52px 1.52px 0px rgba(0, 0, 0, 0.25);
`;

export const Title = styled.h3`
    color: #333;
    text-align: center;
    font-size: 24px;
    font-style: normal;
    font-weight: 900;
    line-height: normal;
    width: 80%;
    max-height: 100%
`;